import styled from 'styled-components';

const NonMonitoredAssetCreateParent = styled.div`
  .header-block {
    margin-bottom: 20px;
  }

  .inner-content {
    height: calc(100vh - 160px);
  }
  .custom-form-layout {
    margin-left: -18px;
  }
`;

const LayoutFormPage = styled.div`
  height: calc(100% - 115px);
  overflow-y: auto;

  .react-grid-item.cssTransforms {
    z-index: 1;
  }
`;

export { NonMonitoredAssetCreateParent, LayoutFormPage };
